import * as React from 'react';
import { formatAmount, getDateFormatWithoutDay } from '../../../webportal/utils/utilFunctions';

interface BillingViewHeaderProps {
    billingForecast?: BillingForecast;
    isCustomPricing: boolean;
    totalPaid: number;
}

interface BillingForecast {
    amountDue: number;
    amountDueForecast: number;
    currency: string;
    trialDays: number;
    start: number;
    end: number;
}

interface BillingViewHeaderState {
}

export class BillingViewHeader extends React.Component<BillingViewHeaderProps, BillingViewHeaderState> {
    constructor(props: BillingViewHeaderProps) {
        super(props);
    }

    async componentDidMount() {
    }

    render() {
        return (
            <div className="row listItem">
                <div className="stat">
                    <span>Current period</span>
                    <h2>{this.renderCurrentBillingPeriod()}</h2>
                </div>
                <div className="stat">
                    <span>Period-to-date balance</span>
                    <h2>{this.renderAmountDue()}</h2>
                </div>
                <div className="stat">
                    <span>Period-end forecast</span>
                    <h2>{this.renderAmountForecast()}</h2>
                </div>
                <div className="stat">
                    <span>Total paid to date</span>
                    <h2>{formatAmount(this.props.totalPaid, this.props.billingForecast?.currency)}</h2>
                </div>
                <div className="stat">
                    <span>Plan type:</span>
                    <h2>{this.props.isCustomPricing ? 'Custom' : 'PayGo'}</h2>
                </div>
            </div>
        );
    }

    private renderCurrentBillingPeriod(): JSX.Element | string {
        if (!this.props.billingForecast) {
            return '0';
        }
        return (
            <React.Fragment>
                {getDateFormatWithoutDay(this.props.billingForecast.start)}
                &nbsp;-&nbsp;
                {getDateFormatWithoutDay(this.props.billingForecast.end)}
            </React.Fragment>
        );
    }

    private renderAmountDue() {
        if (this.props.billingForecast && this.props.billingForecast.amountDue) {
                return (
                    <React.Fragment>
                        {formatAmount(this.props.billingForecast.amountDue, this.props.billingForecast.currency)}
                    </React.Fragment>
                );
            }
        return '0';
    }

    private renderAmountForecast(): JSX.Element | string {
        if (this.props.billingForecast && this.props.billingForecast.amountDueForecast) {
                return (
                    <React.Fragment>
                        {formatAmount(this.props.billingForecast.amountDueForecast, this.props.billingForecast.currency)}
                    </React.Fragment>
                );
            }
        return '0';
    }
}



// WEBPACK FOOTER //
// ./src/backoffice/components/billing/BillingViewHeader.tsx